import { useQuery } from "@/api/swr/useQuery";
import { interviewRecordSchema } from "@/schema/console/interview-records/InterviewRecord";

type Config = Parameters<typeof useQuery<typeof interviewRecordSchema>>[2];

export function useGetInterviewRecord(id: string, config?: Config) {
  return useQuery(
    interviewRecordSchema,
    `/console/re_assessments/${id}/interview_record`,
    config,
  );
}
